import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => {
  return {
    "@global": {
      body: {
        backgroundColor:
          theme.palette && theme.palette.type === "dark"
            ? "#181818"
            : theme.palette && theme.palette.common
              ? theme.palette.common.white
              : "#FFFFFF"
      },
      ...(theme.palette && theme.palette.type === "dark"
        ? {
            ".CircularProgressbar-text": {
              fill: "#f0f0f0 !important"
            },
            ".CircularProgressbar-path": {
              stroke: "#80a3ff !important"
            },
            ".CircularProgressbar-trail": {
              stroke: "rgba(240,240,240,0.12) !important"
            }
          }
        : {})
    },
    wrapper: {
      position: "relative",
      top: "0",
      height: "100vh"
    },
    mainPanel: {
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}px)`
      },
      overflow: "auto",
      position: "relative",
      float: "right",
      ...transition,
      maxHeight: "100%",
      width: "100%",
      overflowScrolling: "touch",
      color:
        theme.palette && theme.palette.type === "dark" ? "#f0f0f0" : "#1d3c40",
      backgroundColor:
        theme.palette && theme.palette.type === "dark" ? "#181818" : "#FFFFFF"
    },
    content: {
      marginTop: "30px",
      padding: "30px 5px",
      minHeight: "calc(100vh - 123px)"
    },
    container: {
      ...(typeof container === "function" ? container(theme) : container)
    },
    map: {
      marginTop: "70px"
    }
  };
};

export default appStyle;
